<template>
  <a-modal
    :confirmLoading='confirmLoading'
    title='选项映射关系配置'
    :visible='visible'
    :width='800'
    @cancel='handleCancel'
    @ok='handleOk'>
    <a-spin :spinning='confirmLoading'>
      <a-table :columns='columns'
               :dataSource='dataSource'
               :loading='confirmLoading'
               :pagination='false'
               rowKey='id'
               size='small'></a-table>


    </a-spin>
  </a-modal>
</template>

<script>
import { postAction } from '@api/manage'

export default {
  name: 'OptionMappingSetting',
  data() {
    return {
      visible: false,
      model: {},
      confirmLoading: false,
      dataSource: []
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '字典项值',
          dataIndex: 'value',
          width: 160,
          align:' center',
          ellipsis: true
        },
        {
          title: '字典项文本',
          dataIndex: 'text',
          align:' center',
          ellipsis: true
        },
        {
          title: '映射',
          align:' center',
          width: 160,
          customRender: (text, record, index) => (<a-input size='small' v-model={record.mappingValue} />)
        },
      ]
    }
  },
  created() {
  },
  methods: {
    view(model) {
      this.model = model
      this.dataSource = JSON.parse(JSON.stringify(model.mappingList))
      this.visible = true
    },
    handleOk() {
      this.$emit('ok',this.model,this.dataSource)
      this.handleCancel()
    },
    handleCancel() {
      this.visible = false
    },
  }

}
</script>

<style scoped>

</style>
